import { useBaskets, useClient, useDictionary } from "@adamlip/okeoke.client"
import WebviewPing from "WebviewPing"
import BottomBar from "components/BottomBar"
import PopUpWindow from "components/Modals/PopUpWindow"
import TopBar from "components/TopBar"
import { MainContext } from "contexts/MainContext"
import { useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
//import "react-smartbanner/dist/main.css"
import "swiper/swiper-bundle.css"
import Routes from "utils/AppRoutes"
import config from "./appConfig"
import BottomBarV2 from "components/BottomBarV2"
import TopBarV2 from "components/TopBarV2"
import { AppParamsContext } from "contexts/AppParamsContext"
import { isDesktop } from "react-device-detect"

function App() {
  const { addModal, popModal, anyModalOpen } = useContext(MainContext)

  const { setSelectedLocation, activeBasketUUID, setActiveBasket } = useClient()
  const navigate = useNavigate()
  const location = useLocation()
  const { baskets } = useBaskets()
  const { getValue } = useDictionary()
  const { appParams, appParamsLoaded } = useContext(AppParamsContext)
  const [shouldOpenPopUpWindow, setShouldOpenPopUpWindow] = useState(false)
  const [newVersionAvailable, setNewVersionAvailable] = useState(false)

  const handleIframeMessage = (event) => {
    //console.log("iFrame event: ", event);
    if (event.data?.action === "selectLocation") {
      navigate(`/select-location/${event.data?.value}`)
    }
    if (event.data?.action === "selectMenu") {
      navigate(`/menu`)
      console.log("Select location in App.js 45")
      setSelectedLocation(event.data?.value?.toUpperCase())
    }
  }

  const backButtonPressed = () => {
    let res = false

    anyModalOpen ? popModal() : (res = true)

    return res
  }

  useEffect(() => {
    //console.log("Add iframe event listener");
    window.addEventListener("message", handleIframeMessage)

    return () => {
      window.removeEventListener("message", handleIframeMessage)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (
      activeBasketUUID == null &&
      baskets != null &&
      Object.keys(baskets || {}).length > 0
    ) {
      setActiveBasket(Object.keys(baskets)[0])
    }
    // eslint-disable-next-line
  }, [baskets, activeBasketUUID])

  useEffect(() => {
    try {
      if (
        process.env.NODE_ENV === "production" &&
        "serviceWorker" in navigator
      ) {
        navigator.serviceWorker
          .register("/brandApp/service-worker.js", { scope: "/brandApp/" })
          .then((registration) => {
            registration.addEventListener("updatefound", () => {
              const installingWorker = registration.installing
              installingWorker.addEventListener("statechange", () => {
                if (installingWorker.state === "installed") {
                  if (navigator.serviceWorker.controller) {
                    const waitingWorker = registration.waiting
                    if (waitingWorker) {
                      console.log("Service worker waiting, skip it")
                      // There's a waiting worker, post a message to skip waiting and activate the new worker
                      waitingWorker.postMessage({ type: "SKIP_WAITING" })
                    }
                    // A new version is available
                    setNewVersionAvailable(true)
                  } else {
                    // The app is newly installed
                    console.log("App installed")
                  }
                }
              })
            })
          })
      }
    } catch (e) {
      console.log(e)
    }
  }, [])

  useEffect(() => {
    if (appParamsLoaded) {
      if (appParams?.popUpWindow?.enabled) {
        setShouldOpenPopUpWindow(true)
      } else {
        setShouldOpenPopUpWindow(false)
      }
    }
    //eslint-disable-next-line
  }, [appParamsLoaded])

  const oldClasses = `mainContent-root ${appParams?.navigation?.navbarElements == null ||
    appParams?.styles?.topBottomBar?.layout === "floating" ||
    appParams?.styles?.topBottomBar?.bottomBarVisible === false ||
    location.pathname.startsWith("/menu")
    ? " no-bottomBar"
    : " !pb-[calc(var(--bottomBar-height)]"
    } ${appParams?.styles?.topBottomBar?.topBarVisible == null ||
      appParams?.styles?.topBottomBar?.topBarVisible === false
      ? " no-topBar"
      : ""
    }`

  const mainClass =
    appParams?.navigation?.bottomBarSettings?.enabled == null ||
      appParams?.navigation?.bottomBarSettings?.enabled === false
      ? oldClasses
      : "overflow-hidden grow"

  return (
    <div
      className={`flex flex-col h-[100dvh] w-full ${appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        }`}
    >
      <PopUpWindow
        isOpen={shouldOpenPopUpWindow}
        setIsOpen={setShouldOpenPopUpWindow}
      />
      <WebviewPing
        backButtonPressed={backButtonPressed}
        addModal={addModal}
        popModal={popModal}
      />
      <div
        style={{
          position: "fixed",
          bottom: "6px",
          left: "6px",
          zIndex: "9999",
          fontSize: "7px",
          opacity: "0.5",
        }}
      >
        {config.version}
      </div>
      {(appParams?.navigation?.topBarSettings?.enabled == null ||
        appParams?.navigation?.topBarSettings?.enabled === false) && <TopBar />}
      {appParams?.navigation?.topBarSettings?.enabled === true && <TopBarV2 />}
      {newVersionAvailable && (
        <div
          className="hidden-content appear w-full"
          style={{
            position: "absolute",
            bottom: "0",
            height: "80px",
            zIndex: "999",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#ff8412",
            textAlign: "center",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={() => window.location.reload(true)}
        >
          {getValue("app_v2_new_version")}
        </div>
      )}
      <section className={`${mainClass} ${isDesktop ? "!pl-[125px]" : ""}`}>
        <Routes />
      </section>
      {(appParams?.navigation?.bottomBarSettings?.enabled == null ||
        appParams?.navigation?.bottomBarSettings?.enabled === false) && (
          <BottomBar />
        )}
      {appParams?.navigation?.bottomBarSettings?.enabled === true && (
        <BottomBarV2 />
      )}
    </div>
  )
}
export default App
